import { render, staticRenderFns } from "./ResourceWMSStyle.vue?vue&type=template&id=19552fa6&scoped=true&"
import script from "./ResourceWMSStyle.vue?vue&type=script&lang=js&"
export * from "./ResourceWMSStyle.vue?vue&type=script&lang=js&"
import style0 from "./ResourceWMSStyle.vue?vue&type=style&index=0&id=19552fa6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19552fa6",
  null
  
)

export default component.exports